import React from "react";
import { observer } from "mobx-react";
import { ContentWrapper } from "./DealershipTeam.styled";
import { CardPanel, Card, IconHighlight, Skeleton, WidgetEmptyErrorPlaceholder } from "@ann/web-components";
import { useDealershipTeamSnapshot } from "../../../../hooks/useDealershipTeamSnapshot";
import { DealershipTeamContent } from "./components";

const DealershipTeam = observer(() => {
  const { loading, error, isEmpty, teamMembers, refetch } = useDealershipTeamSnapshot();

  if (loading) {
    return <Skeleton height="422px" width="100%" />;
  }

  if (error) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <WidgetEmptyErrorPlaceholder
              buttonText="Retry"
              icon="error"
              message="We couldn't load Dealership Team. Please try again."
              onClick={refetch}
              showButton
              title="Something went wrong"
            />
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  if (isEmpty || !teamMembers.length) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <WidgetEmptyErrorPlaceholder
              icon="group"
              message="We'll show info as soon as it's linked or confirmed."
              showButton={false}
              title="No Dealership Team data yet"
            />
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  return (
    <Card size='large'>
      <CardPanel isExpandable={false}>
        <CardPanel.Header title='Dealership Team'>
          <CardPanel.Header.LeftSlot>
            <IconHighlight icon='group' bgColor='primary' iconColor='primary' size='medium' />
          </CardPanel.Header.LeftSlot>
        </CardPanel.Header>
        <CardPanel.Content>
          <ContentWrapper>
            <DealershipTeamContent teamMembers={teamMembers} />
          </ContentWrapper>
        </CardPanel.Content>
      </CardPanel>
    </Card>
  );
});

export default DealershipTeam; 